import I from 'immutable';
import {TranslatorValues, TranslatorFunction, OptionsMap} from 'legacy/js/tool/page/types';

const values: TranslatorValues = {
	options: {},
};

function setTranslator(value: TranslatorFunction) {
	if (location.search.includes('sf_culturex=xl')) { // AP-17915
		__ = (key) => key;

		return;
	}

	__ = value;
}

function getTranslator() {
	return __;
}

function setNetwork(value: string) {
	network = value;
}

function getNetwork() {
	return network;
}

function setOptions(value: OptionsMap, ns?: string) {
	if (value) {
		options = value;
	}

	if (ns) {
		values.options[ns + '_' + 'options'] = value;
	} else {
		values.options.options = value;
	}
}

function getOptions(ns: string) {
	const key = 'options';

	if (ns && values.options.hasOwnProperty(ns + '_' + key)) {
		return values.options[ns + '_' + key];
	}

	if (values.options.hasOwnProperty(key)) {
		return values.options[key];
	}

	throw Error(
		'Get options key "namespace:' + ns + ' from key:' + key + '" is not defined in page/current module.'
	);
}

export const setCurrent = {
	translator: setTranslator,
	network:    setNetwork,
	options:    setOptions,
};

export const getCurrent = {
	translator: getTranslator,
	network:    getNetwork,
	options:    getOptions,
};

export let options = I.Map<string, any>();

export let network = '';

export let __ : (...input: any) => any | TranslatorFunction = (...input) => input[0];
